import api from '../utils/api';

// Fetch all grading scales for a specific grading policy ID
export const getGradingScales = async (gradingPolicyId, headers) => {
  try {
    const response = await api.get('/api/grading/scales', { params: { gradingPolicyId }, ...headers });
    console.log("grading scales ", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching grading scales:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific grading scale by ID
export const getGradingScaleById = async (id, headers) => {
  try {
    const response = await api.get(`/api/grading/scales/${id}`, headers);
    console.log("grading scale by id", response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching grading scale with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new grading scale
export const createGradingScale = async (gradingScaleData, headers) => {
  try {
    const response = await api.post('/api/grading/scales', gradingScaleData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating grading scale:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing grading scale
export const updateGradingScale = async (id, gradingScaleData, headers) => {
  try {
    const response = await api.put(`/api/grading/scales/${id}`, gradingScaleData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating grading scale with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a grading scale
export const deleteGradingScale = async (id, headers) => {
  try {
    const response = await api.delete(`/api/grading/scales/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting grading scale with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
